<template lang="pug">
Spinner(:active="true" size="l")
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useRogue } from '@/js/services/Rogue'
import { messages } from '@/js/app-bridge/messages'

const rogue = useRogue()

onMounted(() => {
  if (rogue.appContext) {
    rogue.emitToApp(messages.DOM_LOADED, {})
  }
})
</script>

<style scoped lang="scss">
.inline-spinner {
  &, :deep(.spinner) {
    display: flex !important;
    align-items: center;
    justify-content: center;
  }

  :deep(.spinner:before) {
    margin: 0 !important;
  }
}
</style>
